export default __webpack_public_path__ + "static/media/logo-white.2c39f953.png";